// Pure helpers of the file import (ImportPanel.jsx; routers/data_imports.py).

export const MODES = [
  { value: "append", label: "Append new rows only" },
  { value: "update", label: "Append, and update rows whose primary key is in the table" },
];

export const ON_ERROR = [
  { value: "all_or_nothing", label: "All or nothing: import only if every row is valid" },
  { value: "valid_only", label: "Valid rows only: skip the rows with errors (download them to fix)" },
];

const plural = (n, one, many) => `${n.toLocaleString("en")} ${n === 1 ? one : many}`;

/** One sentence for the preview's counts. */
export function summaryText(p) {
  if (!p) return "";
  const parts = [`${plural(p.rows, "row", "rows")} in the file`,
                 `${p.ok_rows.toLocaleString("en")} valid`,
                 `${plural(p.error_rows, "row", "rows")} with errors`];
  const what = [`${plural(p.inserts, "new row", "new rows")}`];
  if (p.mode === "update") what.push(`${plural(p.updates, "row", "rows")} to update`);
  // keys of shared entities their hub lacks: the import adds them (insert only, logged)
  for (const [hub, n] of Object.entries(p.new_hub_keys || {})) {
    what.push(`adds ${plural(n, `new ${hub} key`, `new ${hub} keys`)}`);
  }
  return `${parts.join(", ")}; ${what.join(", ")}.`;
}

/** The issues to list: errors first (the server sorted them), each with a readable rule. */
export function issueRows(p) {
  return ((p && p.issues) || []).map((i, n) => ({ ...i, key: `${i.row}-${i.column}-${i.rule}-${n}` }));
}

/** Can the commit go ahead with this choice? -> {ok, why} */
export function canCommit(p, onError) {
  if (!p) return { ok: false, why: "" };
  if (p.blocking && p.blocking.length) return { ok: false, why: "The file cannot be imported as it is (see above)." };
  if (p.error_rows > 0 && onError === "all_or_nothing") {
    return { ok: false, why: "Some rows have errors: fix them, or choose \"Valid rows only\"." };
  }
  const writes = p.inserts + (p.mode === "update" ? p.updates : 0);
  if (writes === 0) return { ok: false, why: "Nothing to import." };
  return { ok: true, why: "" };
}

/** The mapping with "" (the select's empty choice) as null, as the API takes it. */
export function mappingForApi(mapping) {
  const out = {};
  Object.entries(mapping || {}).forEach(([k, v]) => { out[k] = v ? v : null; });
  return out;
}

/** A sentence for a committed import. */
export function resultText(r) {
  if (!r) return "";
  const parts = [`${plural(r.inserted, "row", "rows")} added`];
  if (r.updated) parts.push(`${plural(r.updated, "row", "rows")} updated`);
  if (r.unchanged) parts.push(`${plural(r.unchanged, "row", "rows")} unchanged`);
  if (r.rejected) parts.push(`${plural(r.rejected, "row", "rows")} rejected`);
  return `Imported: ${parts.join(", ")}.`;
}
